import { Grid2 } from "@mui/material";
import {
    Button,
    FormHelperText,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import "../Transactions/transaction.css"
import TextField from "@mui/material/TextField";
import { InputError } from "../Errors/ErrorText";
import { ToastError, ToastSuccess } from "../../CustomToaster/CustomToaster";
import { addBankDetail } from "../../Services/bankdetail";
import backarr from "../../Images/Layer2.svg";
import { useDispatch } from "react-redux";
import { getUserBankList } from "../../Actions/UserBankListAction";

function AddbankDetails() {

    const navigate = useNavigate();
    const [errors, setErrors] = useState({})

    const [bankDetail, setBankDetail] = useState({
        accountHolderName: "",
        accountHolderAddress: "",
        accountNumber: "",
        bankName: "",
        branch: "",
        ifscCode: "",
        swiftCode: ""
    });
    const [isSubmitting, setIsSubmitting] = useState(false);
    const dispatch = useDispatch();

    const handleFormBankDetailChange = (e) => {
        let { name, value } = e.target;

        // Account number → only digits
        if (name === "accountNumber") {
            value = value.replace(/\D/g, "");
        }

        // IFSC & SWIFT → uppercase
        if (name === "ifscCode" || name === "swiftCode") {
            value = value.toUpperCase();
        }

        setBankDetail((prev) => ({
            ...prev,
            [name]: value
        }));

        setErrors((prev) => ({
            ...prev,
            [name]: ""
        }));
    };

    const validateField = (name, value) => {
        let error = "";

        switch (name) {
            case "accountHolderName":
                if (!value.trim()) error = "Account holder name is required";
                break;

            case "accountHolderAddress":
                if (!value.trim()) error = "Address is required";
                break;

            case "accountNumber":
                if (!value) error = "Account number is required";
                else if (!/^\d{9,18}$/.test(value))
                    error = "Account number must be 9-18 digits";
                break;

            case "bankName":
                if (!value.trim()) error = "Bank name is required";
                break;

            case "branch":
                if (!value.trim()) error = "Branch is required";
                break;

            case "ifscCode":
                if (!value) {
                    error = "IFSC code is required (Example: SBIN0001234)";
                } else if (!/^[A-Z]{4}0[A-Z0-9]{6}$/.test(value)) {
                    error = "Invalid IFSC code (Format: 4 letters + 0 + 6 digits. Example: SBIN0001234)";
                }
                break;

            case "swiftCode":
                if (!value) {
                    error = "Swift code is required (Example: SBININBBXXX)";
                }
                else if (value && !/^[A-Z0-9]{8,11}$/.test(value)) {
                    error = "Invalid SWIFT code (8–11 characters. Example: SBININBBXXX)";
                }
                break;

            default:
                break;
        }

        return error;
    };

    const handleBlurValidation = (e) => {
        const { name, value } = e.target;

        const error = validateField(name, value);

        setErrors((prev) => ({
            ...prev,
            [name]: error
        }));
    };

    const validateForm = () => {
        let newErrors = {};

        Object.keys(bankDetail).forEach((field) => {
            const error = validateField(field, bankDetail[field]);
            if (error) newErrors[field] = error;
        });

        setErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    };

    const handleAddBank = async () => {
        if (!validateForm()) return;

        setIsSubmitting(true);

        const updateData = {
            'accountHolderName': bankDetail?.accountHolderName,
            'accountHolderAddress': bankDetail?.accountHolderAddress,
            'accountNumber': bankDetail?.accountNumber,
            'bankName': bankDetail?.bankName,
            'branch': bankDetail?.branch,
            'ifscCode': bankDetail?.ifscCode,
            'swiftCode': bankDetail?.swiftCode,
        };

        try {
            const result = await addBankDetail(updateData);
            if (result?.data?.success) {
                ToastSuccess({ message: "bank created successfull", icon: false });
                dispatch(getUserBankList());
                navigate("/bank-details");

            } else {
                ToastError({
                    message: result?.message || "bank created failed. Please try again.",
                    icon: false,
                });
            }
        } catch (err) {
            setIsSubmitting(false);
        } finally {
            setIsSubmitting(false);
        }
    };
    return (
        <Grid2 container spacing={2} className="mt-20">
            <Grid2 item size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }} >
                <div className="display-1 mb-10 " >
                    <div className="text-left" style={{}} onClick={() => navigate(-1)}>
                        <a>
                            <img src={backarr} />
                        </a>
                    </div>
                    <h2 className="gold-color">Add Bank Details</h2>
                </div>
            </Grid2>
            <Grid2 item size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }} className="card-box" >
                <Grid2 container spacing={2} className="mt-20">
                    <Grid2 item size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}>

                        <div className={`input-common`}>
                            <label>Account Holder Name</label>
                            <TextField
                                name="accountHolderName"
                                placeholder="Account Holder Name"
                                type="text"
                                value={bankDetail?.accountHolderName}
                                inputProps={{ maxLength: 15 }}
                                onChange={handleFormBankDetailChange}
                                onBlur={handleBlurValidation}
                                style={{ width: "100%", marginTop: "5px" }}
                            />
                            <FormHelperText className="color-g">(Name of the person who owns the bank account.)</FormHelperText>

                            <InputError error={errors.accountHolderName} />
                        </div>
                    </Grid2>
                    <Grid2 item size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}>

                        <div className={`input-common`}>
                            <label>Account Holder Address</label>
                            <TextField
                                name="accountHolderAddress"
                                placeholder="Account Holder Address"
                                type="text"
                                value={bankDetail?.accountHolderAddress}
                                onChange={handleFormBankDetailChange}
                                onBlur={handleBlurValidation}
                                inputProps={{ maxLength: 30 }}
                                style={{ width: "100%", marginTop: "5px" }}
                            />
                            <FormHelperText className="color-g">(Registered address of the account holder as per bank records.)</FormHelperText>

                            <InputError error={errors.accountHolderAddress} />
                        </div>
                    </Grid2>
                    <Grid2 item size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}>

                        <div className={`input-common`}>
                            <label>Account Number</label>
                            <TextField
                                name="accountNumber"
                                type="text"
                                value={bankDetail?.accountNumber}
                                onChange={handleFormBankDetailChange}
                                onBlur={handleBlurValidation}
                                inputProps={{ maxLength: 18 }}
                                placeholder="Account Number"
                                style={{ width: "100%", marginTop: "5px" }}
                            />
                            <FormHelperText className="color-g">(Unique bank account number used to receive or send money.)</FormHelperText>

                            <InputError error={errors.accountNumber} />
                        </div>
                    </Grid2>
                    <Grid2 item size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}>

                        <div className={`input-common`}>
                            <label>Bank Name</label>
                            <TextField
                                name="bankName"
                                type="text"
                                value={bankDetail?.bankName}
                                onChange={handleFormBankDetailChange}
                                onBlur={handleBlurValidation}
                                inputProps={{ maxLength: 15 }}
                                placeholder="Bank Name"
                                style={{ width: "100%", marginTop: "5px" }}
                            />
                            <FormHelperText className="color-g">(Name of the bank where the account is maintained.)</FormHelperText>
                            <InputError error={errors.bankName} />
                        </div>
                    </Grid2>
                    <Grid2 item size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}>

                        <div className={`input-common`}>
                            <label>Branch</label>
                            <TextField
                                name="branch"
                                type="text"
                                value={bankDetail?.branch}
                                onChange={handleFormBankDetailChange}
                                onBlur={handleBlurValidation}
                                inputProps={{
                                    maxLength: 18,
                                    inputMode: "numeric",
                                    pattern: "[0-9]*"
                                }}
                                placeholder="Branch"

                                style={{ width: "100%", marginTop: "5px" }}
                            />
                            <FormHelperText className="color-g">(Specific branch of the bank where the account was opened.)</FormHelperText>
                            <InputError error={errors.branch} />
                        </div>
                    </Grid2>
                    <Grid2 item size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}>
                        <div className={`input-common `}>
                            <label>IFSC Code</label>
                            <TextField
                                name='ifscCode'
                                type="text"
                                placeholder="IFSC Code"
                                value={bankDetail?.ifscCode}
                                onChange={handleFormBankDetailChange}
                                onBlur={handleBlurValidation}
                                onKeyDown={(e) => {
                                    const allowedKeys = [
                                        "Backspace",
                                        "Delete",
                                        "ArrowLeft",
                                        "ArrowRight",
                                        "Tab"
                                    ];

                                    if (
                                        !allowedKeys.includes(e.key) &&
                                        !/^[a-zA-Z0-9]$/.test(e.key)
                                    ) {
                                        e.preventDefault();
                                    }
                                }}
                                style={{ width: "100%", marginTop: "5px" }}
                                sx={{
                                    '& .MuiInputAdornment-root': {
                                        marginLeft: 0,
                                        position: 'absolute',
                                        right: '10px',
                                    },
                                }}


                            />

                            <FormHelperText className="color-g">(11-character code used to identify the bank branch for transfers – India only.)</FormHelperText>

                            <InputError error={errors.ifscCode} />
                        </div>
                    </Grid2>

                    <Grid2 item size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}>
                        <div className={`input-common `}>
                            <label>SWIFT Code</label>
                            <TextField
                                name='swiftCode'
                                type="text"
                                placeholder="Swift Code"
                                value={bankDetail?.swiftCode}
                                onChange={handleFormBankDetailChange}
                                onBlur={handleBlurValidation}
                                onKeyDown={(e) => {
                                    const allowedKeys = [
                                        "Backspace",
                                        "Delete",
                                        "ArrowLeft",
                                        "ArrowRight",
                                        "Tab"
                                    ];

                                    if (
                                        !allowedKeys.includes(e.key) &&
                                        !/^[a-zA-Z0-9]$/.test(e.key)
                                    ) {
                                        e.preventDefault();
                                    }
                                }}
                                style={{ width: "100%", marginTop: "5px" }}
                                sx={{
                                    '& .MuiInputAdornment-root': {
                                        marginLeft: 0,
                                        position: 'absolute',
                                        right: '10px',
                                    },
                                }}


                            />

                            <FormHelperText className="color-g">(International bank code used for overseas wire transfers.)</FormHelperText>
                            <InputError error={errors.swiftCode} />
                        </div>
                    </Grid2>

                    <Grid2 item size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                        <div className="blu-btn display-3 mt-20">
                            <Button onClick={handleAddBank} disabled={isSubmitting}>{isSubmitting ? "Processing..." : "Add Bank"}</Button>

                        </div>
                    </Grid2>

                </Grid2>

            </Grid2>


        </Grid2>
    );
}

export default AddbankDetails;
